import { __awaiter, __generator, __read } from "tslib";
import { mergeStyleSets } from '@fluentui/react';
import { Avatar, Body1, Caption1, Card, CardHeader, CardPreview, Text, tokens, } from '@fluentui/react-components';
import { createActivityItem } from '@office-start/activity-control';
import { ActionsMenuButton, RightClickActionsMenu, useActionsMenuRenderer, } from '@office-start/document-control';
import DocumentIconControl from '@office-start/document-icon-control';
import { ActivityNumLines, } from '@office-start/document-types';
import { getKey, KeyboardKey } from '@office-start/keystroke-handler-utility';
import { getLocalizedDateStringDefault, useTransformDateTimeString, } from '@office-start/loc-service';
import React, { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { useCardStyles } from './RecommendedCardControl.styles';
export var RecommendedCardControl = function (_a) {
    var _b, _c, _d, _e, _f;
    var dateResources = _a.dateResources, documentActions = _a.documentActions, getDocumentThumbnail = _a.getDocumentThumbnail, item = _a.item, moreActionsButtonAriaLabel = _a.moreActionsButtonAriaLabel, onDocClick = _a.onDocClick, preferredCulture = _a.preferredCulture, getPersonPicture = _a.getPersonPicture, PeopleCard = _a.PeopleCard, thumbnailPreviewBackgroundColor = _a.thumbnailPreviewBackgroundColor, edgeworthItemResources = _a.edgeworthItemResources, showAppIcon = _a.showAppIcon;
    var cardClasses = useCardStyles();
    var _g = __read(useState(undefined), 2), personPictureUrl = _g[0], setPersonPictureUrl = _g[1];
    useEffect(function () {
        var isMounted = true;
        var getUrl = function () { return __awaiter(void 0, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!getPersonPicture) return [3 /*break*/, 2];
                        return [4 /*yield*/, getPersonPicture(item)];
                    case 1:
                        url = _a.sent();
                        if (isMounted && url) {
                            setPersonPictureUrl("data:image/png;base64,".concat(url));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        getUrl();
        return function () {
            isMounted = false;
        };
    }, [getPersonPicture, item]);
    var _h = __read(useState(undefined), 2), documentThumbnailUrl = _h[0], setDocumentThumbnailUrl = _h[1];
    useEffect(function () {
        var isMounted = true;
        var getThumbnail = function () { return __awaiter(void 0, void 0, void 0, function () {
            var thumbnailUrl;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!getDocumentThumbnail) return [3 /*break*/, 2];
                        return [4 /*yield*/, getDocumentThumbnail(item)];
                    case 1:
                        thumbnailUrl = _a.sent();
                        if (isMounted && thumbnailUrl) {
                            setDocumentThumbnailUrl(thumbnailUrl);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        getThumbnail();
        return function () {
            isMounted = false;
        };
    }, [getDocumentThumbnail, item]);
    var _j = __read(useState(false), 2), thumbnailErrored = _j[0], setThumbnailErrored = _j[1];
    var handleThumbnailError = function () {
        setThumbnailErrored(true);
    };
    var componentRef = useRef(null);
    var timestamp = (_b = item.activity) === null || _b === void 0 ? void 0 : _b.timestamp;
    var fallbackText = timestamp
        ? getLocalizedDateStringDefault(timestamp, preferredCulture)
        : undefined;
    var transformToDateTimeString = useTransformDateTimeString(dateResources, preferredCulture);
    var formatString = (_d = (_c = item.activity) === null || _c === void 0 ? void 0 : _c.formatString) !== null && _d !== void 0 ? _d : '';
    var people = [];
    if (!!item.activity) {
        people = (_e = item.activity) === null || _e === void 0 ? void 0 : _e.people;
    }
    var id = item.activity ? (_f = item.activity) === null || _f === void 0 ? void 0 : _f.id : ' ';
    var activityItem = useMemo(function () {
        return createActivityItem(formatString, ActivityNumLines.Two, transformToDateTimeString(timestamp, false, fallbackText, false), people, id, undefined, undefined, false, PeopleCard);
    }, [
        fallbackText,
        formatString,
        id,
        people,
        timestamp,
        transformToDateTimeString,
        PeopleCard,
    ]);
    var actionMenuItems = (documentActions === null || documentActions === void 0 ? void 0 : documentActions.actionMenuItems) || [];
    var contentActionsEnabled = documentActions === null || documentActions === void 0 ? void 0 : documentActions.contentActionsEnabled;
    var contentActionsGroupInfo = documentActions === null || documentActions === void 0 ? void 0 : documentActions.contentActionsGroupInfo;
    var actionsMenuRenderingPhase = useActionsMenuRenderer(componentRef);
    var AvatarElement = useMemo(function () {
        var _a;
        return (React.createElement(Avatar, { image: personPictureUrl ? { src: personPictureUrl } : undefined, name: (_a = people[0]) === null || _a === void 0 ? void 0 : _a.name, color: "colorful", className: cardClasses.avatar }));
    }, [personPictureUrl, people, cardClasses.avatar]);
    var onKeyPress = useCallback(function (e) {
        var key = getKey(e);
        if (key !== KeyboardKey.Enter && key !== KeyboardKey.Space) {
            return;
        }
        onDocClick();
    }, [onDocClick]);
    return (React.createElement("div", { ref: componentRef },
        React.createElement(Card, { className: cardClasses.root, onClick: onDocClick, onKeyDown: onKeyPress, appearance: "filled", id: item.id, tabIndex: 0 },
            React.createElement(CardHeader, { className: (cardClasses.headerRoot, cardClasses.headerWithIcon), image: React.createElement(React.Fragment, null, PeopleCard ? (React.createElement(PeopleCard, { upn: item.activity.people &&
                        item.activity.people.length
                        ? item.activity.people[0].upn
                        : '' }, AvatarElement)) : (AvatarElement)), header: React.createElement("div", { className: cardClasses.headerTitle },
                    React.createElement(Body1, { truncate: true, className: (cardClasses.body,
                            cardClasses.truncateHeaderText), block: true }, activityItem.activityDescription)), description: React.createElement(Caption1, null, activityItem.timeStamp), action: actionMenuItems.length > 0 &&
                    actionsMenuRenderingPhase ? (React.createElement(ActionsMenuButton, { actions: actionMenuItems, ariaLabel: moreActionsButtonAriaLabel, contentActionsEnabled: contentActionsEnabled, groupInfo: contentActionsGroupInfo, item: item })) : null }),
            React.createElement(CardPreview, { className: cardClasses.preview }, documentThumbnailUrl && !thumbnailErrored ? (React.createElement("img", { className: cardClasses.previewThumbnail, src: documentThumbnailUrl, alt: item.title, onError: handleThumbnailError })) : (React.createElement("div", { className: cardClasses.previewErrorThumbnail, style: mergeStyleSets({ display: 'flex' }, {
                    backgroundColor: thumbnailPreviewBackgroundColor
                        ? thumbnailPreviewBackgroundColor
                        : tokens.colorBrandBackground2,
                }) },
                React.createElement(DocumentIconControl, { item: item, iconSize: "64x64", customIconAltText: edgeworthItemResources === null || edgeworthItemResources === void 0 ? void 0 : edgeworthItemResources.customIconAltText })))),
            showAppIcon ? (React.createElement(CardHeader, { className: (cardClasses.headerWithIcon, cardClasses.headerRoot), image: React.createElement(DocumentIconControl, { item: item, iconSize: "32x32" }), header: React.createElement(Body1, { className: (cardClasses.headerTitle, cardClasses.body) },
                    React.createElement(Text, { truncate: true, className: cardClasses.truncateHeaderText, block: true, weight: "semibold" }, item.title)) })) : (React.createElement(CardHeader, { className: (cardClasses.headerRoot,
                    cardClasses.headerWithoutIcon), header: React.createElement(Body1, { className: (cardClasses.headerTitle, cardClasses.body) },
                    React.createElement(Text, { truncate: true, className: cardClasses.truncateHeaderText, block: true, weight: "semibold" }, item.title)) }))),
        actionMenuItems.length > 0 && actionsMenuRenderingPhase ? (React.createElement(RightClickActionsMenu, { actions: actionMenuItems, componentRef: componentRef, contentActionsEnabled: contentActionsEnabled, groupInfo: contentActionsGroupInfo, item: item })) : null));
};
//# sourceMappingURL=RecommendedCardControl.js.map